import Swiper from 'swiper'

window.addEventListener('DOMContentLoaded', function () {
  if (document.querySelectorAll('.aps-cpd-carousel').length) {
    const carouselNames = ['popular', 'coming-up', 'e-learning', 'on-demand', 'related']
    let swipers = {}

    for (let i in carouselNames) {
      const currentCarousel = `carousel-${carouselNames[i]}`
      const $carousel = document.getElementById(currentCarousel)
      if (!$carousel) {
        continue
      }

      let $cards = $carousel.querySelectorAll('.aps-cpd-card')

      $cards = Array.from($cards)

      swipers[carouselNames[i]] = new Swiper(
        `#${currentCarousel} .aps-cpd-carousel__swiper`,
        {
          slideClass: 'aps-cpd-card',
          spaceBetween: 20,
          navigation: {
            nextEl: '.aps-cpd-carousel__swiper-button-next',
            prevEl: '.aps-cpd-carousel__swiper-button-prev',
          },
          slidesPerView: 1.25,
          breakpoints: {
            480: {
              slidesPerView: 1.5,
            },
            768: {
              spaceBetween: 30,
              slidesPerView: 2.5,
            },
          },
        }
      )

      for (let $card of $cards) {
        const $counter = $card.querySelector('.aps-cpd-card__events-counter')
        const $eventList = $card.querySelectorAll('.aps-cpd-card__event')
        const eventsCount = $eventList.length

        // Handle hiding list of events
        const hideEventsList = function () {
          if ($eventList.length >= 5) {
            for (let i = 1; i < $eventList.length; i++) {
              $eventList[i].classList.add('aps-cpd-card__event--hidden')
            }
            $counter.getElementsByTagName('span')[0].textContent =
              eventsCount - 1
            $counter.classList.add('aps-cpd-card__events-counter--visible')
          }
        }
        // Handle showing list of events
        const showEventsList = function () {
          if ($eventList.length >= 5) {
            for (let i = 1; i < $eventList.length; i++) {
              $eventList[i].classList.remove('aps-cpd-card__event--hidden')
            }
            $counter.getElementsByTagName('span')[0].textContent =
              eventsCount - 1
            $counter.classList.remove('aps-cpd-card__events-counter--visible')
          }
        }

        hideEventsList()

        $card.addEventListener('mouseenter', showEventsList)
        $card.addEventListener('mouseleave', hideEventsList)
        $card.addEventListener('focus', showEventsList)
        $card.addEventListener('blur', hideEventsList)
      }

      const $navPrev = $carousel.querySelector('.aps-cpd-carousel__swiper-button-prev')
      const $navNext = $carousel.querySelector('.aps-cpd-carousel__swiper-button-next')
      $navPrev.classList.add('aps-cpd-carousel__swiper-button-disabled')

      $navPrev.addEventListener('click', () => {
        if ($navPrev.classList.contains('aps-cpd-carousel__swiper-button-disabled')) return
        swipers[carouselNames[i]].slidePrev()
      })

      $navNext.addEventListener('click', () => {
        if ($navNext.classList.contains('aps-cpd-carousel__swiper-button-disabled')) return
        swipers[carouselNames[i]].slideNext()
      })

      swipers[carouselNames[i]].on('slideChange', () => {
        if (swipers[carouselNames[i]].isBeginning) {
          $navPrev.classList.add('aps-cpd-carousel__swiper-button-disabled')
          $navNext.classList.remove('aps-cpd-carousel__swiper-button-disabled')
        } else if (swipers[carouselNames[i]].isEnd) {
          $navNext.classList.add('aps-cpd-carousel__swiper-button-disabled')
          $navPrev.classList.remove('aps-cpd-carousel__swiper-button-disabled')
        } else {
          $navPrev.classList.remove('aps-cpd-carousel__swiper-button-disabled')
          $navNext.classList.remove('aps-cpd-carousel__swiper-button-disabled')
        }
      })
    }
  }
})
